<!-- 货场信息编辑页 -->
<template>
  <div class="app-container order-detail-wrap">
    <el-form
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      label-width="120px"
    >
      <!-- 基础信息模块 -->
      <basic-info-section
        :form-data="formData.goodsYardInfoReq"
        :management-options="managementOptions"
        :partnership-type="partnershipType"
        :province-list="provinceList"
        :city-list="cityList"
        :district-list="districtList"
        :town-list="townList"
        :business-category="businessCategory"
        @update:org-name="updateOrgName"
        @province-change="handleProvinceChange"
        @city-change="handleCityChange"
        @district-change="handleDistrictChange"
        @town-change="handleTownChange"
      />

      <!-- 走访信息模块 -->
      <visit-info-section :form-data="formData.goodsYardVisitReq" />

      <!-- 竞企信息模块 -->
      <competitive-info-section
        :competitors-data="formData.goodsYardCompetitorsReqs"
        :competitors-list="competitorsList"
        @add="addCompetitiveEnterprise"
        @remove="remove"
        @update:competitor-name="updateCompetitorsName"
      />
    </el-form>

    <div class="bottom-wrap">
      <el-row class="row" justify="center" type="flex">
        <el-button @click="$router.go(-1)">返回</el-button>
        <el-button type="primary" @click="handleSubmit">更新</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getYardInfo,
  updateYard,
  getManagementList,
  getCompetitorsList,
} from "@/api/goodsYard";
import BasicInfoSection from "./components/BasicInfoSection";
import VisitInfoSection from "./components/VisitInfoSection";
import CompetitiveInfoSection from "./components/CompetitiveInfoSection";
import mixin from "./mixin";

export default {
  name: "goodsYardEdit",
  mixins: [mixin],
  components: {
    BasicInfoSection,
    VisitInfoSection,
    CompetitiveInfoSection,
  },
  computed: {
    baseUrl() {
      return process.env.BASE_API;
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      managementOptions: [],
      competitorsList: [],
      partnershipType: null,
      provinceList: [],
      cityList: [],
      districtList: [],
      townList: [],
      businessCategory: {},
      formData: {
        goodsYardInfoReq: {
          goodsYardCode: "",
          orgId: "",
          goodsYardUser: "",
          goodsYardPhone: "",
          provinceCode: "",
          provinceName: "",
          cityCode: "",
          cityName: "",
          districtCode: "",
          districtName: "",
          townCode: "",
          townName: "",
          address: "",
          goodsYardSquare: "",
          monthNum: "",
          yearNum: "",
          businessCategory: [],
        },
        goodsYardVisitReq: {
          visitDate: "",
          goodsYardInventory: "",
          singleAirconditionRecyclePrice: "",
          doubleAirconditionRecyclePrice: "",
          singleAirconditionSellPrice: "",
          doubleAirconditionSellPrice: "",
          latestShipmentPlan: "",
          latestSupplyDate: "",
          partnerMode: "",
          sourceFlow: "",
          cooperativeSuppliers: "",
        },
        goodsYardCompetitorsReqs: [

        ],
      },
      updateList: [],
    };
  },
  async created() {
    this.partnershipType = JSON.parse(localStorage.getItem("partnershipType"));
    await this.initializeData();
  },
  methods: {
    async initializeData() {
      try {
        await Promise.all([
          this.getManagementOptions(),
          this.getCompetitorsList(),
          this.getTblProvince(),
        ]);
        if (this.id) {
          await this.getDetail();
        }
      } catch (error) {}
    },
    async getManagementOptions() {
      const params = {
        partnershipType: 1,
        pageNum: 1,
        pageSize: 999,
      };
      const { statusCode, data } = await getManagementList(params);
      if (statusCode === 200) {
        this.managementOptions = data.records;
      }
    },
    async getCompetitorsList() {
      const { statusCode, data } = await getCompetitorsList();
      if (statusCode === 200) {
        this.competitorsList = data;
      }
    },
    async getDetail() {
      const { statusCode, data } = await getYardInfo(this.id);
      if (statusCode === 200) {
        this.formData.goodsYardInfoReq = data.goodsYardInfoResp || {};
        // this.formData.goodsYardVisitReq = data.goodsYardVisitResp || {};
        // this.formData.goodsYardCompetitorsReqs = data.goodsYardCompetitorsResps || [];

        if (this.formData.goodsYardInfoReq.orgId) {
          this.updateOrgName(this.formData.goodsYardInfoReq.orgId);
        }

        if (this.formData.goodsYardInfoReq.provinceCode) {
          await this.getTblCity(this.formData.goodsYardInfoReq.provinceCode);
        }
        if (this.formData.goodsYardInfoReq.cityCode) {
          await this.getTblCounty(this.formData.goodsYardInfoReq.cityCode);
        }
        if (this.formData.goodsYardInfoReq.districtCode) {
          await this.getTblTown(this.formData.goodsYardInfoReq.districtCode);
        }
      }
    },
    async handleProvinceChange(province) {
      const formData = this.formData.goodsYardInfoReq;
      formData.cityCode = "";
      formData.cityName = "";
      formData.districtCode = "";
      formData.districtName = "";
      formData.townCode = "";
      formData.townName = "";

      const selectedProvince = this.provinceList.find(
        (item) => item.id === province
      );
      if (selectedProvince) {
        formData.provinceName = selectedProvince.name;
      }

      await this.getTblCity(province);
    },
    async handleCityChange(city) {
      const formData = this.formData.goodsYardInfoReq;
      formData.districtCode = "";
      formData.districtName = "";
      formData.townCode = "";
      formData.townName = "";

      const selectedCity = this.cityList.find((item) => item.id === city);
      if (selectedCity) {
        formData.cityName = selectedCity.name;
      }

      await this.getTblCounty(city);
    },
    async handleDistrictChange(district) {
      const formData = this.formData.goodsYardInfoReq;
      formData.townCode = "";
      formData.townName = "";

      const selectedDistrict = this.districtList.find(
        (item) => item.id === district
      );
      if (selectedDistrict) {
        formData.districtName = selectedDistrict.name;
      }

      await this.getTblTown(district);
    },
    handleTownChange(town) {
      const selectedTown = this.townList.find((item) => item.id === town);
      if (selectedTown) {
        this.formData.goodsYardInfoReq.townName = selectedTown.name;
      }
    },
    addCompetitiveEnterprise() {
      this.formData.goodsYardCompetitorsReqs.push({
        competitorsId: "",
        competitorsName: "",
        singleAirconditionRecyclePrice: "",
        doubleAirconditionRecyclePrice: "",
      });
    },
    remove(index) {
      this.$confirm("确认删除该竞企?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      }).then(() => {
        this.formData.goodsYardCompetitorsReqs.splice(index, 1);
      });
    },
    updateCompetitorsName(row) {
      const selectedCompetitor = this.competitorsList.find(
        (competitor) => competitor.id == row.competitorsId
      );
      if (selectedCompetitor) {
        row.competitorsName = selectedCompetitor.competitorsName;
      }
    },
    updateOrgName(selectedOrgId) {
      const selectedOrg = this.managementOptions.find(
        (item) => item.partnershipId == selectedOrgId
      );
      if (selectedOrg) {
        this.formData.goodsYardInfoReq.orgName = selectedOrg.partnerName;
      }
    },
    validateCompetitiveEnterprise() {
      const pricePattern =
        /^(?:[1-9]\d{0,9}(?:\.\d{1,2})?|0\.\d[1-9]|0\.[1-9]\d?)$/;

      return this.formData.goodsYardCompetitorsReqs.every((item, index) => {
        const errorMsg = [];
        let isValid = true;

        const hasMissingField =
          !item.competitorsId ||
          !item.singleAirconditionRecyclePrice ||
          !item.doubleAirconditionRecyclePrice;

        if (hasMissingField) {
          errorMsg.push("信息不完整");
          isValid = false;
        }


        if (
          item.competitorsId &&
          item.singleAirconditionRecyclePrice &&
          item.doubleAirconditionRecyclePrice
        ) {
          if (!pricePattern.test(item.singleAirconditionRecyclePrice)) {
            errorMsg.push("单片收货价需大于0，至多两位小数，长度不超10字符。");
            isValid = false;
          }
          if (!pricePattern.test(item.doubleAirconditionRecyclePrice)) {
            errorMsg.push("双片收货价需大于0，至多两位小数，长度不超10字符。");
            isValid = false;
          }
        }

        if (!isValid) {
          this.$message.error(
            `竞企信息第${index + 1}行：${errorMsg.join("，")}`
          );
        }
        return isValid;
      });
    },
    async handleSubmit() {
      try {
        await this.$refs.ruleForm.validate();
        // 添加竞企信息验证
        if (!this.validateCompetitiveEnterprise()) {
          return;
        }
        await this.$confirm("确认提交货场信息?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
        });

        this.formData.goodsYardCompetitorsReqs =
          this.formData.goodsYardCompetitorsReqs.map((competitor, index) => ({
            ...competitor,
            orderNum: index + 1,
          }));

        const { statusCode, message } = await updateYard(this.formData);

        if (statusCode === 200) {
          this.$message.success("更新成功");
          this.$router.go(-1);
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        console.error("Submit failed:", error);
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.order-detail-wrap {
  .module-wrap {
    margin-bottom: 10px;
  }

  .sub-title {
    font-size: 16px;
    font-weight: bold;
    color: rgb(48, 49, 51);
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .image-style {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }

  .total-price {
    font-size: 12px;
    color: #606266;
    margin-top: 10px;
  }

  .footer-wrap {
    display: flex;
    justify-content: flex-end;
  }

  .downLoadLink {
    color: #1459c0;
    cursor: pointer;
  }

  .bottom-wrap {
    margin-top: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataBoard/goodsYardEdit.vue